function mapLockInit(idMapWrap){
    const wrapMap = document.querySelector(idMapWrap);
    const mapTitle = document.createElement('div');
    mapTitle.className = 'mapTitle';
    mapTitle.textContent = 'Для активации карты нажмите по ней';
    
    wrapMap.appendChild(mapTitle);
    wrapMap.addEventListener('click', (e) => {
        e.currentTarget.children[0].removeAttribute('style');
        mapTitle.parentElement.removeChild(mapTitle);
    })

    wrapMap.addEventListener('mousemove', (e)=> {
        mapTitle.classList.add('mapTitle--active');
        if(e.offsetY > 10)mapTitle.style.top = e.offsetY + 20 + 'px';
        if(e.offsetX > 10)mapTitle.style.left = e.offsetX + 20 + 'px';
    })

    wrapMap.addEventListener('mouseout', (e)=> {
        mapTitle.classList.remove('mapTitle--active')
    })
};
try{
    mapLockInit('#wrapMap');

} catch(e){

}
try{
    mapLockInit('#wrapPointMap');
} catch(e){

}
try{
    mapLockInit('#shopMap');
} catch(e){

}
